/* @flow */
import type { Action, AsyncAction, FindSmartlistParams } from '../../types';

import liferay from '../../services/api';

const onFailure = (error: Object) => console.warn(error);

const fetchSmartlists = (params: FindSmartlistParams): AsyncAction => {
  //$FlowFixMe
  return {
    type: 'FETCH_SMARTLISTS_REQUEST',
    payload: params,
    promise: liferay.smartlists.find(params),
    meta: { onFailure },
  };
};

const smartlistsSetPageScroll = (pageScroll: number): Action => {
  return {
    type: 'SMARTLISTS_SCROLL_PAGE',
    payload: pageScroll,
  };
};

export default {
  fetchSmartlists,
  smartlistsSetPageScroll,
};
